// extracted by mini-css-extract-plugin
export default {"cls1":"RatingCard-cls1__Ge","cls2":"RatingCard-cls2_DWG RatingCard-cls1__Ge"};